var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import { useMemo } from 'react';
import useStorage from '@src/hooks/useStorage';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import enUS from '@arco-design/web-react/es/locale/en-US';
function useAppContext() {
  var _a = __read(useStorage('arco-lang', 'en-US'), 2),
    lang = _a[0],
    setLang = _a[1];
  var arcoLocale = useMemo(function () {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      case 'en-US':
        return enUS;
      default:
        return enUS;
    }
  }, [lang]);
  var contextValue = {
    lang: lang,
    setLang: setLang
  };
  return {
    arcoLocale: arcoLocale,
    contextValue: contextValue
  };
}
export default useAppContext;